var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnabled)?_c('Renderer',_vm._g({attrs:{"value":_vm.value,"schema":_vm.schema,"config":_vm.config,"data-key":_vm.schema.key,"default-expanded":_vm.defaultExpanded},on:{"input":$ev => _vm.$emit('input', $ev)}},_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }